module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "background fullfill"
  }, [_c('div', {
    staticClass: "overlay fullfill"
  }), (_vm.pageInfo.background && _vm.pageInfo.background.video && _vm.showVideo) ? _c('video', {
    ref: "backgroundVideo",
    staticClass: "background-video",
    style: (_vm.videoCss),
    attrs: {
      "autoplay": "autoplay",
      "loop": "loop",
      "plays-inline": "plays-inline"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.pageInfo.background.video,
      "type": "video/mp4"
    }
  })]) : _vm._e(), (_vm.pageInfo.background && _vm.pageInfo.background.image && !_vm.showVideo) ? _c('div', {
    staticClass: "background-image",
    style: ('background-image: url(' + _vm.pageInfo.background.image + _vm.getOptimalImageSize('crop', 'fullwidth', null) + ')')
  }) : _vm._e()]), _c('div', {
    staticClass: "content fullfill table"
  }, [_c('div', {
    staticClass: "table-cell"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.pageInfo.phrase) ? _c('h1', {
    staticClass: "head"
  }, [_vm._v(_vm._s(_vm.pageInfo.phrase[_vm.$i18n.locale]))]) : _vm._e()])]), (_vm.pageInfo.showreel) ? _c('div', {
    staticClass: "showreel-link"
  }, [_c('a', {
    staticClass: "grey action",
    on: {
      "click": function($event) {
        _vm.$refs.modal.open()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('$buttons.showreel')))])]) : _vm._e()]), _c('modal', {
    ref: "modal",
    staticClass: "video-modal",
    on: {
      "opened": _vm.pauseBackgroundVideo,
      "closed": _vm.playBackgroundVideo
    }
  }, [(_vm.pageInfo.showreel) ? _c('video-block', {
    ref: "showreelVideo",
    attrs: {
      "content": _vm.pageInfo.showreel
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63f0d2b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Main.vue
// module id = 175
// module chunks = 4